<template>
  <div @click="eventoclick()">
    <template>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>{{ nome }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </template>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  props: ["id", "nome"],
  created() {},
  methods: {
    eventoclick() {
      this.$emit("evento");
    }
  }
};
</script>